import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircleOutline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "1em",
	viewBox: "0 -960 960 960",
	width: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M480-160a320 320 0 1 1 0-640a320 320 0 1 1 0 640Zm0-80a240 240 0 1 0 0-480a240 240 0 1 0 0 480Z" })
});
export default SvgCircleOutline;
